import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";

// ✅ Libera <img> no sanitize (sem isso, imagens somem)
const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames || []), "img", "figure", "figcaption"],
  attributes: {
    ...(defaultSchema.attributes || {}),
    img: ["src", "alt", "title", "loading", "decoding", "referrerpolicy"],
    figure: ["className"],
    figcaption: ["className"],
    a: ["href", "title", "target", "rel"],
  },
  protocols: {
    ...(defaultSchema.protocols || {}),
    src: ["http", "https"],
    href: ["http", "https", "mailto"],
  },
};

export default function MarkdownArticle({ content = "" }) {
  return (
    <div className="prose prose-slate max-w-none prose-headings:scroll-mt-24">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[[rehypeSanitize, sanitizeSchema]]}
        components={{
          // Títulos (opcional)
          h1: ({ children, ...props }) => (
            <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight" {...props}>
              {children}
            </h1>
          ),
          h2: ({ children, ...props }) => (
            <h2 className="mt-8 text-2xl font-bold tracking-tight" {...props}>
              {children}
            </h2>
          ),
          h3: ({ children, ...props }) => (
            <h3 className="mt-6 text-xl font-bold" {...props}>
              {children}
            </h3>
          ),

          // Links mais seguros
          a: ({ children, href, ...props }) => (
            <a
              href={href}
              target="_blank"
              rel="noreferrer noopener"
              className="text-blue-600 hover:text-blue-700 underline underline-offset-2"
              {...props}
            >
              {children}
            </a>
          ),

          // ✅ Imagens do Markdown
          img: ({ src, alt, ...props }) => {
            if (!src) return null;

            return (
              <figure className="my-8">
                <img
                  src={src}
                  alt={alt || "Imagem"}
                  loading="lazy"
                  decoding="async"
                  referrerPolicy="no-referrer"
                  className="w-full max-w-4xl mx-auto rounded-2xl border border-slate-200 shadow-sm"
                  {...props}
                />
                {alt ? (
                  <figcaption className="mt-3 text-center text-sm text-slate-500">
                    {alt}
                  </figcaption>
                ) : null}
              </figure>
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
